import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';

import { RoutePaths } from '../../constants';
import { BackLink } from './Navigation/BackLink';
import { SearchButton } from './SearchButton';
import { navigateOut } from '../../utils';
import ModalSwitcher from './ModalSwitcher/index';
import { Typography } from './Typography';

import { TOP_BAR_DEVICE_RENAME } from 'config';

const DEVICE_RENAME: any = TOP_BAR_DEVICE_RENAME;

const HomeDiv = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 5px 10px;
  height: 54px;
  background-color: var(--sys-color--surface);
  color: var(--sys-color--on-surface);
`;

const CenterTitleContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 8px;
`;

const BackDiv = styled.div`
  position: absolute;
  left: 10px;
  padding: 6px;
  display: flex;
  align-items: center;
`;

const SearchDiv = styled.div`
  position: absolute;
  right: 10px;
  padding: 5px 10px;
  width: 41px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

const mapStateToProps = (state: any) => {
  const {
    features: { flags },
    currentUser
  } = state.registry;

  let deviceName = currentUser?.device?.productName;
  if (deviceName && DEVICE_RENAME[deviceName]) {
    deviceName = DEVICE_RENAME[deviceName];
  }

  return {
    showSearch: flags.showSearch,
    enableTiles: flags.enable_tiles,
    deviceName
  };
};

type ReduxProps = ReturnType<typeof mapStateToProps>;

interface HomeContainerProps extends ReduxProps {
  selected?: RoutePaths;
  centerTitle?: string;
}

class HomeContainer extends React.Component<HomeContainerProps, any> {

  render() {
    const { showSearch, selected } = this.props;
    let goBack;
    if (selected && [RoutePaths.DEVICE, RoutePaths.LEGACY_DEVICE, RoutePaths.GALLERY_CLOCKS, RoutePaths.GALLERY_APPS, RoutePaths.GALLERY_TILES].includes(selected)) {
      goBack = () => {
        navigateOut();
      }
    }

    return (
      <div>
        <ModalSwitcher />
        <HomeDiv>
          <BackDiv>
            <BackLink backNavigate={goBack} />
          </BackDiv>
          <div>
            {this.renderCenterContent()}
          </div>
          <SearchDiv>
            {false && <SearchButton />}
          </SearchDiv>
        </HomeDiv>
        <div>
          {this.props.children}
        </div>
      </div>
    )
  }

  private renderCenterContent() {
    const { centerTitle } = this.props;

    return (
      <CenterTitleContainer>
        <Typography variant="titleLarge">{centerTitle}</Typography>
      </CenterTitleContainer>
    );
  }

}

export default connect(mapStateToProps)(HomeContainer);
